/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ButtonVisitChoice/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import "DesignSystem/Fonts/Inter-400.css"
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function ButtonVisitChoice({
  children,
  viewPath = "/DesignSystem/ButtonVisitChoice",
  alignSelf = "auto",
  borderBottomLeftRadius = 5,
  borderBottomRightRadius = 5,
  borderColor = "#e5e5e5",
  borderTopLeftRadius = 5,
  borderTopRightRadius = 5,
  borderLeftWidth = 1,
  borderRightWidth = 1,
  marginLeft = 0,
  marginTop = 0,
  marginRight = 0,
  onClick,
  width = 0,
  isSelected,
  text = "label"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isSelected})
  return (<React.Fragment
>
<button
  data-testid="ButtonVisitChoice.ButtonSecondary:1"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--as-1-Z2kMpb8': alignSelf,'--bblr-3-Z2kMpb8': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-Z2kMpb8': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-6-Z2kMpb8': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-7-Z2kMpb8': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--blw-8-Z2kMpb8': typeof borderLeftWidth === 'number' ? `${borderLeftWidth}px` : borderLeftWidth,'--brw-9-Z2kMpb8': typeof borderRightWidth === 'number' ? `${borderRightWidth}px` : borderRightWidth,'--ml-10-Z2kMpb8': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mt-11-Z2kMpb8': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mr-12-Z2kMpb8': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--w-13-Z2kMpb8': typeof width === 'number' ? `${width}px` : width,'--bc-2-Z2kMpb8': isSelected ? "rgba(0,147,201, 0.83)" : isHovered ? "rgba(0,147,201, 0.05)" : "#ffffff",'--bc-5-Z2kMpb8': isSelected ? "#0093c9" : isHovered ? "rgba(0,147,201, 0.83)" : borderColor}}
 className={`views-block ${styles.ButtonSecondary}`}
>
<span
  data-testid="ButtonVisitChoice.Text"
  data-view-path={viewPath}
 style={{'--c-14-Z2kMpb8': isSelected ? "#ffffff" : isHovered ? "rgba(0,147,201, 0.83)" : "#323232"}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
</button>
{children}
</React.Fragment>)
}